var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { inject, observer } from 'mobx-react';

import { MarkdownPanel } from 'sdc-markdown-viewer';

import './AlertHint.scss';

var AlertHint = inject('languagesStore', 'labelsStore')(observer(function (_ref) {
  var languagesStore = _ref.languagesStore,
      labelsStore = _ref.labelsStore,
      topic = _ref.topic,
      hidden = _ref.hidden,
      props = _objectWithoutProperties(_ref, ['languagesStore', 'labelsStore', 'topic', 'hidden']);

  return languagesStore.languagesAvailable.length > 0 && !hidden ? React.createElement(
    'div',
    _extends({ className: 'alert alert-hint alert-warning' }, props),
    React.createElement(MarkdownPanel, { ignoreIndex: true, text: labelsStore.labelFor(topic), className: 'markdown-panel' })
  ) : null;
}));
export { AlertHint };